export const isRtl = ({ language }) => language === 'ar';
